/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ImageManagementAddImageUploadResponse } from './ImageManagementAddImageUploadResponse';

export type ImageManagementAddImageUploadResponseApiRespoonse = {
    data?: ImageManagementAddImageUploadResponse;
    status?: ImageManagementAddImageUploadResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace ImageManagementAddImageUploadResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

